<template>
  <!-- 設定更新 -->
  <div>
    <CCard>
      <CCardHeader>
        <h2>設定更新</h2>
      </CCardHeader>
      <CCardBody>
        <span class="asterisk">*</span>
        <span style="margin-bottom: 1rem; display: inline-block">
          が付いている項目は必須入力項目です
        </span>

        <ValidationObserver ref="obs" v-slot="ObserverProps">
          <CRow>
            <div class="container">
              <table class="table table-borderless">

                <!-- エラー表示 -->
                <tr v-if="message.length">
                  <td colspan="2">
                    <ul>
                      <li v-for="error in message" :key="error" style="color: red;">{{ error }}</li>
                    </ul>
                  </td>
                </tr>

                <!-- 各項目 -->
                <tr>
                  <td colspan="2">
                    <h5 class="section-title mt-4 mb-2">基本情報</h5>
                  </td>
                </tr>
                <tr>
                  <th scope="row">会社名<span class="asterisk">*</span></th>
                  <td>
                    <ValidationProvider name="会社名" rules="required|max:20" v-slot="ProviderProps">
                      <CInput v-model="company_name"  style="max-width: 500px" />
                      <p class="error"><font color="red">{{ ProviderProps.errors[0] }}</font></p>
                    </ValidationProvider>
                  </td>
                </tr>

                <tr>
                  <th scope="row">電話番号</th>
                  <td>
                    <ValidationProvider name="電話番号" rules="tel" v-slot="ProviderProps">
                      <CInput v-model="telephone" style="max-width: 200px" description="ハイフンなしで入力してください" />
                      <p class="error"><font color="red">{{ ProviderProps.errors[0] }}</font></p>
                    </ValidationProvider>
                  </td>
                </tr>

                <tr>
                  <th scope="row">定時前打刻猶予時間<span class="asterisk">*</span></th>
                  <td>
                    <ValidationProvider name="定時前打刻猶予時間" rules="required|hourMinute" v-slot="ProviderProps">
                      <CInput v-model="pre_buffer" class="narrow-input" />
                      <p class="error"><font color="red">{{ ProviderProps.errors[0] }}</font></p>
                    </ValidationProvider>
                  </td>
                </tr>

                <tr>
                  <th scope="row">定時後打刻猶予時間<span class="asterisk">*</span></th>
                  <td>
                    <ValidationProvider name="定時後打刻猶予時間" rules="required|hourMinute" v-slot="ProviderProps">
                      <CInput v-model="post_buffer" class="narrow-input" />
                      <p class="error"><font color="red">{{ ProviderProps.errors[0] }}</font></p>
                    </ValidationProvider>
                    <div class="d-flex align-items-center mt-2">
                      <label class="custom-switch mb-0">
                        <input
                          type="checkbox"
                          class="custom-switch-input"
                          id="overTimeBreakFlg"
                          v-model="post_work_break_flg"
                        />
                        <span class="custom-switch-indicator" aria-hidden="true"></span>
                      </label>
                      <label for="overTimeBreakFlg" class="ml-2 mb-0">
                        定時後打刻猶予時間を休憩とする
                      </label>
                    </div>
                  </td>
                </tr>

                <tr>
                  <th scope="row">勤務時間の最小単位<span class="asterisk">*</span></th>
                  <td>
                    <ValidationProvider name="勤務時間の最小単位" rules="required|hourMinute" v-slot="ProviderProps">
                      <CInput v-model="work_time_unit" class="narrow-input" />
                      <p class="error"><font color="red">{{ ProviderProps.errors[0] }}</font></p>
                    </ValidationProvider>
                  </td>
                </tr>

                <tr>
                  <th scope="row">規定定時間<span class="asterisk">*</span></th>
                  <td>
                    <ValidationProvider name="規定定時間" rules="required|hourMinute" v-slot="ProviderProps">
                      <CInput v-model="work_basic" class="narrow-input" />
                      <p class="error"><font color="red">{{ ProviderProps.errors[0] }}</font></p>
                    </ValidationProvider>
                  </td>
                </tr>

                <tr>
                  <th scope="row">規定休憩時間<span class="asterisk">*</span></th>
                  <td>
                    <ValidationProvider name="規定休憩時間" rules="required|hourMinute" v-slot="ProviderProps">
                      <CInput v-model="break_basic" class="narrow-input" />
                      <p class="error"><font color="red">{{ ProviderProps.errors[0] }}</font></p>
                    </ValidationProvider>
                    <div class="d-flex align-items-center mt-2">
                      <label class="custom-switch mb-0">
                        <input
                          type="checkbox"
                          class="custom-switch-input"
                          id="useProjectBreakFlg"
                          v-model="use_project_break_flg"
                        />
                        <span class="custom-switch-indicator" aria-hidden="true"></span>
                      </label>
                      <label for="useProjectBreakFlg" class="ml-2 mb-0">
                        プロジェクト設定の休憩時間を自動設定する
                      </label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <h5 class="section-title mt-4 mb-2">Slack通知</h5>
                  </td>
                </tr>
                <tr>
                  <th scope="row">workspaceトークン</th>
                  <td>
                    <ValidationProvider name="workspaceトークン" rules="max:100" v-slot="ProviderProps">
                      <CInput v-model="slack_token"  style="max-width: 500px" />
                      <p class="error"><font color="red">{{ ProviderProps.errors[0] }}</font></p>
                    </ValidationProvider>
                  </td>
                </tr>
                <tr>
                  <th scope="row">チャンネルID</th>
                  <td>
                    <ValidationProvider name="チャンネルID" rules="max:20" v-slot="ProviderProps">
                      <CInput v-model="slack_channel"  style="max-width: 500px" />
                      <p class="error"><font color="red">{{ ProviderProps.errors[0] }}</font></p>
                    </ValidationProvider>
                  </td>
                </tr>
              </table>

              <!-- ボタン -->
              <div class="button-row-local">
              <button class="btn btn-secondary" @click="valueCheck">戻る</button>
              <button class="btn btn-info ml-2 center-button" @click="openModal" :disabled="ObserverProps.invalid">確認</button>
              </div>
              <!-- モーダル -->
              <SettingUpdateModal
                :draggable="true"
                :resizable="true"
                :company_name="company_name"
                :telephone="telephone"
                :pre_buffer="pre_buffer"
                :post_buffer="post_buffer"
                :work_time_unit="work_time_unit"
                :work_basic="work_basic"
                :post_work_break_flg="post_work_break_flg"
                :break_basic="break_basic"
                :use_project_break_flg="use_project_break_flg"
                :slack_token="slack_token"
                :slack_channel="slack_channel"
                :loading="loading"
                v-show="showModal"
                @update="update"
                @close="closeModal"
              />
            </div>
          </CRow>
        </ValidationObserver>
      </CCardBody>
    </CCard>
  </div>
</template>


<script>
import ConstList from '../ConstList'
import SettingUpdateModal from './SettingUpdateModal'
import axios from 'axios'
export default {
  name: 'SettingUpdate',
  components: {
    SettingUpdateModal
  },
  data() {
    return {
      showModal: false,
      company_name: '',
      telephone: '',
      pre_buffer: '',
      post_buffer: '',
      work_basic: '',
      work_time_unit: '',
      break_basic: '',
      post_work_break_flg: false,
      use_project_break_flg: false,
      slack_token: '',
      slack_channel: '',
      items: [],
      message: [],
      company_check: [],
      loading: false,
    }
  },
  methods: {
    // プロジェクト詳細へ遷移する際の入力値チェック
    valueCheck: function () {
      if ((this.company_name) || (this.telephone) || (this.pre_buffer) || (this.post_buffer) 
      || (this.work_basic) || (this.work_time_unit) || (this.post_work_break_flg)|| (this.break_basic)
      || (this.use_project_break_flg) || (this.slack_token )|| (this.slack_channel)) {
        if (confirm(ConstList.TRANSITION)) {
          this.$router.push({
            name: ConstList.ROUTE_SETTING,
            params: {
              value: this.$route.params.value
            }
          })
        }
      } else {
        this.$router.push({
          name: ConstList.ROUTE_SETTING,
          params: {
            value: this.$route.params.value
          }
        })
      }
    },
    // モーダルを表示
    openModal: function () {
      // モーダル表示（toggle）
      this.showModal = true
    },
    // 更新情報を送信
    update: function () {
      this.loading = true;
      // JSON形式パラメータ設定
      const params = {
        id : this.$route.params.value.id,
        company_name : this.company_name,
        telephone : this.telephone,
        pre_buffer : this.pre_buffer,
        post_buffer : this.post_buffer,
        work_basic : this.work_basic,
        work_time_unit : this.work_time_unit,
        break_basic : this.break_basic,
        post_work_break_flg : this.post_work_break_flg,
        use_project_break_flg : this.use_project_break_flg,
        slack_token : this.slack_token,
        slack_channel : this.slack_channel
      }
      axios
        .post((process.env.VUE_APP_API_ORIGIN) + '/setting/update', params,  
          { headers: {
             // content-type指定。@requestBodyでサーバ側にてバインドするため。
             'Content-Type': 'application/json' 
          }},)
        .then(() => {
          alert(ConstList.REGISTER_MESSAGE)
          this.showModal = false
          // 設定画面へ遷移する
          this.$router.push({
            name: ConstList.ROUTE_SETTING
          })
        })
        .catch(error => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // モーダルを閉じる
    closeModal: function () {
      this.showModal = false
    }
  },

  // DBから各種情報を取得
  mounted: function () {
    this.company_name = this.$route.params.value.company_name
    this.telephone = this.$route.params.value.telephone
    this.pre_buffer = this.$route.params.value.pre_buffer
    this.post_buffer = this.$route.params.value.post_buffer
    this.work_basic = this.$route.params.value.work_basic
    this.work_time_unit = this.$route.params.value.work_time_unit
    this.break_basic = this.$route.params.value.break_basic
    this.post_work_break_flg = this.$route.params.value.post_work_break_flg
    this.use_project_break_flg = this.$route.params.value.use_project_break_flg
    this.slack_token = this.$route.params.value.slack_token
    this.slack_channel = this.$route.params.value.slack_channel
  }
}
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}

.narrow-input {
  width: 80px;
}
.button-row-local {
  display: flex;
  justify-content: space-between;
  margin-top: 2em;
  max-width: 45%;
}
</style>
